import { PaginationRestDTO } from '@bottega52/commons-pagination';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import qs from 'qs';
import { JagoAxiosInstance } from './JagoAxiosInstance';
import { ICylindersRequestParamsDTO, IKeysRequestParamsDTO, IMksImportsRequestParamsDTO, IMechanicalCylinderKeyRelationsRequestParamsDTO } from './model/output/RequestParamsDTOs';
import { ICylinderInDTO } from './model/input/ICylinderInDTO';
import { IKeyInDTO } from './model/input/IKeyInDTO';
import { IMksImportInDTO } from './model/input/IMksImportInDTO';
import { ICsvPreviewInDTO } from './model/input/ICsvPreviewInDTO';
import { IMechanicalCylinderKeyRelationInDTO } from './model/input/IMechanicalCylinderKeyRelationInDTO';
import { 
  IMKSRequestDTO, 
  IMKSRequestInDTO, 
  IMKSRequestUpdateDTO, 
  IMKSRequestStatusChangeDTO, 
  IMKSRequestParamsDTO 
} from './model/output/IMKSRequestDTO';

export function fetchCylinders(params: ICylindersRequestParamsDTO): Promise<AxiosResponse<PaginationRestDTO<ICylinderInDTO>>> {
  const config: AxiosRequestConfig = {
    params: {
        ...params,
        hostname: undefined,
    },
  };
  return JagoAxiosInstance.get(`api/v2/support/mks/${params.hostname}/mechanicalCylinders`, config);
}

export function fetchKeys(params: IKeysRequestParamsDTO): Promise<AxiosResponse<PaginationRestDTO<IKeyInDTO>>> {
  const config: AxiosRequestConfig = {
    params: {
        ...params,
        hostname: undefined,
    },
  };
  return JagoAxiosInstance.get(`api/v2/support/mks/${params.hostname}/mechanicalKeys`, config);
}

export function fetchMksImports(params: IMksImportsRequestParamsDTO): Promise<AxiosResponse<PaginationRestDTO<IMksImportInDTO>>> {
  const config: AxiosRequestConfig = {
    params: {
        ...params,
        hostname: undefined,
        sort: 'importTimestamp,desc', // Ordinamento fisso per data decrescente
    },
  };
  return JagoAxiosInstance.get(`api/v2/support/mks/${params.hostname}/mechanicalCylinderKeyRelations/imports`, config);
}

export function previewCsvData(hostname: string, fileFormat: string, file: File): Promise<AxiosResponse<ICsvPreviewInDTO>> {
  const formData = new FormData();
  formData.append('file', file);
  
  const config: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  
  return JagoAxiosInstance.post(`api/v2/support/mks/${hostname}/mechanicalCylinderKeyRelations/imports/csv/preview?fileType=${fileFormat}`, formData, config);
}

export function importMechanicalCylindersFromCsv(hostname: string, fileFormat: string, file: File): Promise<AxiosResponse<any>> {
  const formData = new FormData();
  formData.append('file', file);
  
  const config: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  
  return JagoAxiosInstance.post(`api/v2/support/mks/${hostname}/mechanicalCylinderKeyRelations/imports/csv?fileType=${fileFormat}`, formData, config);
}

export function fetchMechanicalCylinderKeyRelations(params: IMechanicalCylinderKeyRelationsRequestParamsDTO): Promise<AxiosResponse<PaginationRestDTO<IMechanicalCylinderKeyRelationInDTO>>> {
  const config: AxiosRequestConfig = {
    params: {
        ...params,
        hostname: undefined,
    },
    paramsSerializer: (params: any) => qs.stringify(params, { arrayFormat: 'repeat' }),
  };
  return JagoAxiosInstance.get(`api/v2/support/mks/${params.hostname}/mechanicalCylinderKeyRelations`, config);
}

// MKS Request API functions
export function fetchMKSRequests(params: IMKSRequestParamsDTO): Promise<AxiosResponse<PaginationRestDTO<IMKSRequestDTO>>> {
  const config: AxiosRequestConfig = {
    params: {
      ...params,
      statuses: params.status || undefined,
      status: undefined,
    },
    paramsSerializer: (params: any) => qs.stringify(params),
  };
  return JagoAxiosInstance.get('api/v2/support/mks/requests', config);
}

export function exportMKSRequests(params: Omit<IMKSRequestParamsDTO, 'page' | 'pageSize'>): Promise<AxiosResponse<IMKSRequestDTO[]>> {
  const config: AxiosRequestConfig = {
    params,
    paramsSerializer: (params: any) => qs.stringify(params),
  };
  return JagoAxiosInstance.get('api/v2/support/mks/requests/export', config);
}

export function fetchMKSRequestById(requestId: number): Promise<AxiosResponse<IMKSRequestDTO>> {
  return JagoAxiosInstance.get(`api/v2/support/mks/requests/${requestId}`);
}

export function createMKSRequest(data: IMKSRequestInDTO): Promise<AxiosResponse<IMKSRequestDTO>> {
  return JagoAxiosInstance.post('api/v2/support/mks/requests', data);
}

export function updateMKSRequest(requestId: number, data: IMKSRequestUpdateDTO): Promise<AxiosResponse<IMKSRequestDTO>> {
  return JagoAxiosInstance.put(`api/v2/support/mks/requests/${requestId}`, data);
}

export function changeMKSRequestStatus(requestId: number, data: IMKSRequestStatusChangeDTO): Promise<AxiosResponse<IMKSRequestDTO>> {
  return JagoAxiosInstance.put(`api/v2/support/mks/requests/${requestId}/status`, data);
}

export function deleteMKSRequest(requestId: number): Promise<AxiosResponse<IMKSRequestDTO>> {
  return JagoAxiosInstance.delete(`api/v2/support/mks/requests/${requestId}`);
}
